import styled from "styled-components"

export const Wrapper = styled.div`
  margin-top:5px;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  @media screen and (max-width: 600px) {
    border: 0;
  }
`

export const THead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TBody = styled.tbody`
  padding: 1px;
  box-shadow: 0 0 0 1px #ddd;
  border-radius: 4px;
  font-size: 14px;

  @media screen and (max-width: 600px) {
    padding: 0;
    box-shadow: none;
    border-radius: 0;
  }
`

export const TR = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }

  @media screen and (max-width: 600px) {
    display: block;
    margin-bottom: 25px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
`

export const TH = styled.th`
  padding: 10px 25px;
  font-size: 14px;
  text-align:left;

  cursor: ${p=>p.sortable ? 'pointer' : 'default'};

  &:last-child {
    border-bottom: 0;
    text-align:right;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 10px;
  }
`

export const TD = styled.td`
  padding: 15px 25px;


  @media screen and (max-width: 600px) {
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;
    display: block;
    text-align: right;

    &:before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  text-align: left;

  &:last-child {
    text-align: right;
  }
`

export const Icon = styled.em`
  margin-right: 6px;
  color: #1F78AE;
`

export const Text = styled.span`
  color: #1F78AE;
  font-weight: bold;
`